import { HttpMethod } from '../../components/Common/useFetch';
import { RequestOptions } from '../../components/Common/useRequest';
import useUserOrKaEmployeeRequest from '../../components/Common/useUserOrEmployeeRequest';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';
import { FieldAlyticsSettings } from './useGetFieldAlyticsSettings';

const useUpdateFieldAlyticsSettings = (options?: RequestOptions) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrKaEmployeeRequest<FieldAlyticsSettings>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/settings`, method: HttpMethod.PUT },
    options
  );
};

export default useUpdateFieldAlyticsSettings;
